import axios from './axios';
import { urlPrefix, uploadUrlPrefix, openUrl, tglPrefix } from './config.js';

//退出登录
export const UserLogin = () => axios.post(`${urlPrefix}/user/login`);
// 获取用户信息
export const UserBrief = () => axios.get(`${urlPrefix}/user/brief`);
// 获取用户是否有权限参加活动
export const UserActivityAuth = params =>
    axios.get(`${urlPrefix}/user/activity/auth`, {
        params: params
    });

//获取用户的活动投稿列表
export const UserActivityArticles = params =>
    axios.get(`${urlPrefix}/articles/activity/list`, {
        params: params
    });
//获取用户媒体账号
export const UserMediaAccount = () =>
    axios.get(`${urlPrefix}/media/user/account`);
//获取用户媒体账号
export const MediaAuth = params =>
    axios.get(`${urlPrefix}/media/auth`, {
        params: params
    });

export const UploadUrl = `${uploadUrlPrefix}/plupload/upload`;
// 活动视频投稿
export const ArticleSaveVideo = params =>
    axios.post(`${urlPrefix}/articles/activity`, params);
// 获取媒体列个表
export const MediaList = params =>
    axios.get(`${urlPrefix}/media/list`, {
        params: params
    });

export const AllGame = () => axios.get(`${urlPrefix}/game/all`);

export const RecentGame = () => axios.get(`${urlPrefix}/game/user/recent`);

export const SaveArticleDraft = params =>
    axios.post(`${urlPrefix}/articles/draft/text`, params);

export const SaveArticle = params =>
    axios.post(`${urlPrefix}/articles/save/text`, params);

export const ArticleDetail = id =>
    axios.get(`${urlPrefix}/articles/detail`, {
        params: {
            id: id
        }
    });

export const ArticleUgcDetail = id =>
    axios.get(`${urlPrefix}/articles/ugc/detail`, {
        params: {
            id: id
        }
    });

export const DraftDetail = id =>
    axios.get(`${urlPrefix}/articles/draftDetail`, {
        params: {
            draftId: id
        }
    });

// ugc审核列表
export const CheckList = params =>
    axios.get(`${urlPrefix}/articles/ugc/list`, {
        params: params
    });

export const RejectHandle = params =>
    axios.post(`${urlPrefix}/articles/ugc/reject`, params);
//  游戏列表
export const GameList = () => axios(`${urlPrefix}/game/all`);
// ugc视频保存
export const SaveUgcVideo = params =>
    axios.post(`${urlPrefix}/articles/save/video`, params);
// ugc视频保存草稿
export const SaveDraftUgcVideo = params =>
    axios.post(`${urlPrefix}/articles/draft/video`, params);

// 获取视频信息
export const GetVideoInfo = id =>
    axios.get(`${urlPrefix}/attachment/video/review`, {
        params: {
            id: id
        }
    });

export const ReviewVideoUrl = `${urlPrefix}/attachment/video/review`;

export const ReviewVideoUrl2 = `${uploadUrlPrefix}/attachment/showVideoNew`;

// ugc发布操作
export const Publish = params =>
    axios.post(`${urlPrefix}/articles/ugc/publish`, params);
// 判断是否有ugc权限
export const CheckListAuth = () => axios(`${urlPrefix}/user/verity`);

export const RealName = () => axios(`${urlPrefix}/user/info`);

// 用户媒体帐号分组
export const MediaUserAccountGroup = () =>
    axios(`${urlPrefix}/media/user/account/group`);

// 公用媒体帐号分组
export const MediaPubAccountGroup = params =>
    axios(`${urlPrefix}/media/pub/account/group`, {
        params
    });

//删除用户媒体账号
export const DelUserMediaAccount = `${urlPrefix}/media/user/account`;

// 数据-获取作者文章列表
export const GetArticleList = params =>
    axios.get(`${urlPrefix}/data/getArticleList`, {
        params: params
    });

// 数据-获取媒体频道列表
export const GetExternalChannels = () =>
    axios(`${urlPrefix}/data/getExternalChannels`);

// 数据-获取活动列表
export const GetUserActivityList = () =>
    axios(`${urlPrefix}/data/getUserActivityList`);

// 数据-获取订单列表
export const GetUserOrderList = () =>
    axios(`${urlPrefix}/data/getUserOrderList`);

// 数据-获取指定文章数据
export const GetArticlePvVvDaily = params =>
    axios.get(`${urlPrefix}/data/getArticlePvVvDaily`, {
        params: params
    });

// 获取作者文章自发布日起的15天阅读量
export const Get15DaysStatistics = params =>
    axios.get(`${urlPrefix}/data/get15DaysStatistics`, {
        params: params
    });

// QQ域 V4 版本 START

// 个人作者申请时数据
export const UserApplyInfo = () => axios(`${urlPrefix}/user/apply/info`);
// 用户认证申请
export const UserApply = params =>
    axios.post(`${urlPrefix}/user/apply`, params);

// 自由投稿内容审核list
export const ugcApproveList = params =>
    axios.get(`${urlPrefix}/articles/ugc/list`, {
        params: params
    });

// 自由投稿实名认证和流量奖励
export const UserUgcIdentity = params =>
    axios.get(`${urlPrefix}/user/ugcIdentity`, {
        params: params
    });

// 自由投稿内容审核数据
export const ugcApproveListStat = params =>
    axios.get(`${urlPrefix}/articles/ugc/listSummary`, {
        params: params
    });

// 自由投稿审核通过
export const ugcArticlePublish = params =>
    axios.post(`${urlPrefix}/articles/ugc/publish`, params);
// 自由投稿审核驳回
export const ugcArticleReject = params =>
    axios.post(`${urlPrefix}/articles/ugc/reject`, params);

// 内容管理 V4 版本 S

// 内容管理-数据统计
export const ArticleStatistics = params =>
    axios.get(`${urlPrefix}/articles/manager/statistic`, {
        params: params
    });
// 自由投稿-内容列表
export const UgcArticleList = params =>
    axios.get(`${urlPrefix}/articles/manager/ugc/list`, {
        params: params
    });
// 自由投稿-草稿列表
export const UgcArticleDraftList = params =>
    axios.get(`${urlPrefix}/articles/manager/ugc/draft`, {
        params: params
    });

export const UgcArticleDrafDelete = params =>
    axios.delete(`${urlPrefix}/articles/manager/ugc/draft`, {
        params: params
    });

export const ArticleDelete = id =>
    axios.post(`${urlPrefix}/articles/delete`, {
        id: id
    });

// 作者订单-投稿列表
export const DemandArticleList = params =>
    axios.get(`${urlPrefix}/articles/manager/demand/list`, {
        params: params
    });

// 作者订单-select框
export const OwnDemandList = () => axios.get(`${urlPrefix}/demand/own`);

// 活动投稿-投稿列表
export const ActivityArticleList = params =>
    axios.get(`${urlPrefix}/articles/manager/activity/list`, {
        params: params
    });

// 活动投稿-投稿草稿列表
export const ActivityArticleListDraft = params =>
    axios.get(`${urlPrefix}/articles/manager/mission/draft`, {
        params: params
    });

// 活动投稿-活动草稿详情
export const ActivityDraftInfo = params =>
    axios.get(`${urlPrefix}/articles/mission/draft/info`, {
        params: params
    });

// 活动投稿-活动草稿删除
export const ActivityDraftDelete = params =>
    axios.delete(`${urlPrefix}/articles/manager/mission/draft`, {
        data: params
    });

// 作者活动-投稿列表
export const ActivityList = () => axios.get(`${urlPrefix}/activity/list`);

/********************************************* V4 热点雷达 start********************************************************/

// 内容趋势-一周内容建议
export const TrendAdviseTagList = params =>
    axios.get(`${urlPrefix}/trend/adviseTags`, {
        params: params
    });
// 内容趋势-内容趋势图表数据
export const ContentTrendsData = params =>
    axios.get(`${urlPrefix}/trend/contentTrends`, {
        params: params
    });
// 内容趋势-热词趋势
export const KeywordTrendsData = params =>
    axios.get(`${urlPrefix}/trend/keywordTrends`, {
        params: params
    });
// 热词分析-热词趋势
export const HotTagTrendData = params =>
    axios.get(`${urlPrefix}/trend/hotTagTrend`, {
        params: params
    });
// 热词分析-热词相关文章
export const HotTagArtList = params =>
    axios.get(`${urlPrefix}/trend/hotTagArtList`, {
        params: params
    });
// 热门视频数据
export const TrendHotVideoData = params =>
    axios.get(`${urlPrefix}/trend/hotVideo`, {
        params: params
    });
// 热点雷达热点词汇
export const TrendHotTagData = params =>
    axios.get(`${urlPrefix}/trend/hotTag`, {
        params: params
    });

/********************************************* V4 热点雷达 end  ********************************************************/

/********************************************* V4 订单投稿 start********************************************************/

// 个人外团派单-订单图文投稿
export const ContributeText = params =>
    axios.post(`${urlPrefix}/articles/demand/text`, params);
// 个人外团派单-订单视频投稿
export const ContributeVideo = params =>
    axios.post(`${urlPrefix}/articles/demand/video`, params);
// 个人外团派单-订单小说投稿
export const ContributeNovel = params =>
    axios.post(`${urlPrefix}/articles/demand/novel`, params);
// 个人外团派单-订单漫画投稿
export const ContributeCartoon = params =>
    axios.post(`${urlPrefix}/articles/demand/painting`, params);

// 投稿 拉取腾讯视频vid信息
export const GetVidInfo = params =>
    axios.get(`${urlPrefix}/attachment/video/vqqInfo`, {
        params: params
    });

// 订单投稿的内容详情
export const DemandArticleDetails = params =>
    axios.get(`${urlPrefix}/articles/demand/detail`, {
        params: params
    });

// 个人订单投稿 标签-select-box
export const GameTags = params =>
    axios.get(`${urlPrefix}/game/tags`, {
        params: params
    });
// 个人订单投稿 关键词-select-box
export const GameKeywords = params =>
    axios.get(`${urlPrefix}/game/keywords`, {
        params: params
    });

// 个人订单投稿 内部渠道、发布渠道
export const GameChannels = params =>
    axios.get(`${urlPrefix}/game/channels`, {
        params: params
    });

// 个人订单投稿 用户绑定的外部媒体账号
export const UserMediaAccountList = params =>
    axios.get(`${urlPrefix}/media/user/account`, {
        params: params
    });

// 用户绑定媒体账号 - 分组
export const UserMediaAccountGroup = params =>
    axios.get(`${urlPrefix}/media/user/account/group`, {
        params: params
    });

// 个人订单投稿 公共外部媒体账号
export const PublicMediaAccountList = params =>
    axios.get(`${urlPrefix}/media/pub/account`, {
        params: params
    });

// 投稿编目 媒体分类
export const MediaCategories = params =>
    axios.get(`${urlPrefix}/media/category`, {
        params: params
    });

/********************************************* V4 订单投稿 end**********************************************************/

/********************************************* V4 个人订单 start********************************************************/

// 用户所拥有的个人或者供应商订单
export const UserOwnDemand = params =>
    axios.get(`${urlPrefix}/demand/own`, {
        params: params
    });
// 个人派单统计
export const PersonDemandStat = params =>
    axios.get(`${urlPrefix}/demand/person/statistic`);
// 个人派单列表
export const PersonDemandList = params =>
    axios.get(`${urlPrefix}/demand/person/list`, {
        params: params
    });
// 个人派单需求明细信息
export const PersonDemandItemInfo = params =>
    axios.get(`${urlPrefix}/demand/person/item/info`, {
        params: params
    });

export const PersonDemandArticleList = params =>
    axios.get(`${urlPrefix}/demand/person/article/list`, {
        params: params
    });
// 个人外团订单明细项关联内容列表
export const PersonDemandAttachments = params =>
    axios.get(`${urlPrefix}/demand/person/attachment/list`, {
        params: params
    });

// 个人外团订单 提交验收件
export const PersonAttachmentSubmit = params =>
    axios.post(`${urlPrefix}/demand/person/attachment/submit`, params);
// 个人外团订单 删除验收件
export const PersonAttachmentDelete = params =>
    axios.post(`${urlPrefix}/demand/person/attachment/delete`, params);
// 个人外团订单明细项关联内容列表
export const PersonDemandAcceptList = params =>
    axios.get(`${urlPrefix}/demand/person/accept`, {
        params: params
    });
// 个人外团派单-接单
export const AcceptPersonDemand = params =>
    axios.post(`${urlPrefix}/demand/person/accept`, params);
// 个人外团派单-提交验收
export const SubmitPersonDemand = params =>
    axios.post(`${urlPrefix}/demand/person/submit`, params);
// 个人外团派单-确认收款
export const ConfirmPayment = params =>
    axios.post(`${urlPrefix}/demand/person/pay/confirm`, params);
// 个人外团派单-确认未收款
export const ConfirmUnpaid = params =>
    axios.post(`${urlPrefix}/demand/person/pay/unreceived`, params);

/********************************************* V4 个人订单投稿 end  ****************************************************/

/********************************************* V4 供应商订单 start  ****************************************************/
// 说明： 供应商需求单=> 供应商订单=> 作者订单=>
// 用户供应商派单角色判断
export const SupplierIdentity = () =>
    axios.get(`${urlPrefix}/user/supplier/identity`);

// 供应商订单-需求单列表
export const SupplierDemandList = params =>
    axios.get(`${urlPrefix}/demand/supplier/demand/list`, {
        params: params
    });
// 供应商需求单- 列表各状态内容统计
export const SupplierDemanStat = params =>
    axios.get(`${urlPrefix}/demand/supplier/demand/summary`, {
        params: params
    });
// 供应商单- 供应商订单列表
export const SupplierOrderList = params =>
    axios.get(`${urlPrefix}/demand/supplier/supplierOrder/list`, {
        params: params
    });
// 供应商派单需求单详情
export const SupplierDemandInfo = params =>
    axios.get(`${urlPrefix}/demand/supplier/demand/info`, {
        params: params
    });

// 供应商子订单详情
export const SupplierOrderInfo = params =>
    axios.get(`${urlPrefix}/demand/supplier/supplierOrder/info`, {
        params: params
    });
// 供应商子订单-派单的作者列表
export const AssignSupplierOrderInfo = params =>
    axios.get(`${urlPrefix}/demand/supplier/supplierOrder/author`, {
        params: params
    });
// 供应商订单-派单
export const AssignSupplierOrder = params =>
    axios.post(`${urlPrefix}/demand/supplier/supplierOrder/assign`, params);
// 供应商订单-删除
export const DeleteSupplierOrder = params =>
    axios.post(`${urlPrefix}/demand/supplier/supplierOrder/delete`, params);
// 供应商订单-提审
export const SubmitSupplierOrder = params =>
    axios.post(`${urlPrefix}/demand/supplier/supplierOrder/audit`, params);
// 供应商订单-提请结单
export const SubmitStatement = params =>
    axios.post(`${urlPrefix}/demand/supplier/supplierOrder/statement`, params);
// 供应商订单-新建或保存供应商订单
export const SaveSupplierOrder = params =>
    axios.post(`${urlPrefix}/demand/supplier/supplierOrder/save`, params);

// 作者订单详情
export const AuthorOrderInfo = params =>
    axios.get(`${urlPrefix}/demand/supplier/authorOrder/info`, {
        params: params
    });
// 作者订单列表
export const SupplierAuthorOrderList = params =>
    axios.get(`${urlPrefix}/demand/supplier/supplierOrder/authorOrder/list`, {
        params: params
    });

export const AuthorOrderList = params =>
    axios.get(`${urlPrefix}/demand/supplier/authorOrder/list`, {
        params: params
    });
// 作者订单列表
export const AuthorOrderStat = params =>
    axios.get(`${urlPrefix}/demand/supplier/authorOrder/summary`, {
        params: params
    });

// 作者订单 - 作者确认接单
export const AuthorAcceptOrder = params =>
    axios.post(`${urlPrefix}/demand/supplier/authorOrder/confirmOrder`, params);

// 作者订单 - 作者提请结单
export const AuthorSubmitAuthorOrder = params =>
    axios.post(`${urlPrefix}/demand/supplier/authorOrder/submit`, params);

// 删除作者订单
export const DeleteAuthorOrder = params =>
    axios.post(`${urlPrefix}/demand/supplier/authorOrder/delete`, params);
// 供应商中止作者订单
export const StopAuthorOrder = params =>
    axios.post(`${urlPrefix}/demand/supplier/authorOrder/stop`, params);
// 供应商 "结单中止"作者订单
export const SupplierStopToStatement = params =>
    axios.post(
        `${urlPrefix}/demand/supplier/authorOrder/stopToStatement`,
        params
    );
// 供应商驳回作者订单
export const SupplierRejectAuthorOrder = params =>
    axios.post(`${urlPrefix}/demand/supplier/authorOrder/reject`, params);
// 作者订单 关联人列表
export const AuthorOrderRelationList = params =>
    axios.get(`${urlPrefix}/demand/supplier/authorOrder/relation/list`, {
        params: params
    });
// 供应商新建作者-作者订单
export const SaveAuthorOrder = params =>
    axios.post(`${urlPrefix}/demand/supplier/authorOrder/save`, params);
// 作者订单导入团成员
export const AuthorOrderImportTeam = params =>
    axios.post(`${urlPrefix}/demand/supplier/authorOrder/team`, params);

// 添加关联人
export const AddRelativePerson = params =>
    axios.post(
        `${urlPrefix}/demand/supplier/authorOrder/relation/save`,
        params
    );
// 删除关联人
export const DeleteRelativePerson = params =>
    axios.post(
        `${urlPrefix}/demand/supplier/authorOrder/relation/delete`,
        params
    );

// 获取供应商需求单内容
export const SupplierDemandArticleList = params =>
    axios.get(`${urlPrefix}/demand/supplier/article/list`, {
        params: params
    });
export const SupplierOrderArticleList = params =>
    axios.get(`${urlPrefix}/demand/supplier/order/article/list`, {
        params: params
    });
export const AuthorOrderArticleList = params =>
    axios.get(`${urlPrefix}/demand/supplier/author/article/list`, {
        params: params
    });

// 供应商订单-内容审核通过/驳回
export const SupplierArticlePass = params =>
    axios.post(`${urlPrefix}/demand/supplier/article/pass`, params);
export const SupplierArticleReject = params =>
    axios.post(`${urlPrefix}/demand/supplier/article/reject`, params);

/********************************************* V4 供应商订单 end  ****************************************************/

// 内容管理 V4 版本 E

// QQ域 V4 版本 End

// 团队管理- 所有团队
export const TeamAll = () => axios(`${urlPrefix}/team/all`);

// 团队管理-创建的团队
export const TeamOwned = () => axios(`${urlPrefix}/team/owned`);

// 团队管理-加入的团队
export const TeamJoined = () => axios(`${urlPrefix}/team/joined`);

// 团队管理-团队成员
export const TeamMember = params =>
    axios.get(`${urlPrefix}/team/member`, {
        params: params
    });

// 团队管理-创建团队
export const TeamCreate = params =>
    axios.post(`${urlPrefix}/team/create`, params);

// 团队管理-邀请成员
export const TeamMemberInvite = params =>
    axios.post(`${urlPrefix}/team/member/invite`, params);

// 团队管理-删除成员
export const TeamMemberDelete = params =>
    axios.post(`${urlPrefix}/team/member/delete`, params);

// 团队管理-同意加入
export const TeamInviteAgree = params =>
    axios.post(`${urlPrefix}/team/invite/agree`, params);

// 团队管理-拒绝加入
export const TeamInviteReject = params =>
    axios.post(`${urlPrefix}/team/invite/reject`, params);

export const DataGetStatistics = params =>
    axios.get(`${urlPrefix}/data/getStatistics`, {
        params: params
    });

// 个人中心数据
export const UserCenter = () => axios(`${urlPrefix}/user/center`);

// 个人总收益
export const UserCenterIncome = () => axios(`${urlPrefix}/user/center/income`);

export const incomeOverview = () => axios(`${urlPrefix}/income/overview`);

export const incomeDetailList = params =>
    axios.get(`${urlPrefix}/income/detail`, {
        params: params
    });

export const accountDetailList = params =>
    axios.get(`${urlPrefix}/income/accountDetail`, {
        params: params
    });

export const dailyDetailList = params =>
    axios.get(`${urlPrefix}/income/dailyTable`, {
        params: params
    });

export const incomeDailyGraph = params =>
    axios.get(`${urlPrefix}/income/dailyGraph`, {
        params: params
    });

export const profitItemList = params =>
    axios.get(`${urlPrefix}/income/flowDetail`, {
        params: params
    });

export const incomeFlowAccount = params =>
    axios.get(`${urlPrefix}/income/flowAccount`, {
        params: params
    });

export const dailyFlowList = params =>
    axios.get(`${urlPrefix}/income/dailyFlow`, {
        params: params
    });

export const dailyMissionDetailList = params =>
    axios.get(`${urlPrefix}/income/missionDaily`, {
        params: params
    });

export const missionIncomeDetailList = params =>
    axios.get(`${urlPrefix}/income/missionDetail`, {
        params: params
    });

export const missionAccountDetailList = params =>
    axios.get(`${urlPrefix}/income/missionAccount`, {
        params: params
    });

// QQ登录
// export const QQLogin = () => axios(`${urlPrefix}/qq/login/url`);

export const QQLogin = params =>
    axios.get(`${urlPrefix}/qq/login/url`, {
        params: params
    });

// 微信登录
export const WXLogin = () => axios(`${urlPrefix}/wx/login/url`);

// 退出登录
export const loginOut = () => axios(`${urlPrefix}/user/logout`);

// 腾讯视频绑定
export const vqqBind = params =>
    axios.post(`${urlPrefix}/media/vqq/bind`, params);

// QQ看点绑定
export const kandianBind = params =>
    axios.post(`${urlPrefix}/media/kandian/bind`, params);

// 微信绑定
export const WXbind = () => axios(`${urlPrefix}/wx/bind/url`);

// QQ绑定
export const QQbind = () => axios(`${urlPrefix}/qq/bind/url`);

/** ******************************************* V4 任务相关 start  ****************************************************/
export const TaskList = params =>
    axios.get(`${urlPrefix}/mission/list`, {
        params: params
    });
export const TaskAll = params => axios.get(`${urlPrefix}/mission/all`);
export const TaskDetail = params =>
    axios.get(`${urlPrefix}/mission/detail`, {
        params: params
    });
export const TaskBrief = params =>
    axios.get(`${urlPrefix}/mission/brief`, {
        params: params
    });
export const TaskAddVideo = params =>
    axios.post(`${urlPrefix}/articles/mission/video`, params);
export const TaskEditVideo = params =>
    axios.post(`${urlPrefix}/articles/mission/video/edit`, params);
export const TaskAddArticle = params =>
    axios.post(`${urlPrefix}/articles/mission/text`, params);
export const TaskEditArticle = params =>
    axios.post(`${urlPrefix}/articles/mission/text/edit`, params);

// 图文保存草稿
export const TaskEditArticleDraft = params =>
    axios.post(`${urlPrefix}/articles/mission/text/draft`, params);

// 视频保存草稿
export const TaskEditVideoDraft = params =>
    axios.post(`${urlPrefix}/articles/mission/video/draft`, params);

export const TaskVerifyList = params =>
    axios.get(`${urlPrefix}/articles/mission/verify/list`, {
        params: params
    });
export const TaskVerifyPass = params =>
    axios.post(`${urlPrefix}/articles/mission/verify/pass`, params);
export const TaskVerifyRject = params =>
    axios.post(`${urlPrefix}/articles/mission/verify/reject`, params);
export const TaskVerifyStatus = params =>
    axios.get(`${urlPrefix}/articles/mission/verify/summary`);
export const TaskMyArticleList = params =>
    axios.get(`${urlPrefix}/articles/manager/mission/list`, {
        params: params
    });
export const TaskMyArticleListAll = params =>
    axios.get(`${urlPrefix}/articles/manager/mission/list/all`, {
        params: params
    });
// 活动宣传页配置
export const MissionConfig = params =>
    axios.get(`${urlPrefix}/mission/config`, {
        params: params
    });
/** ******************************************* V4 任务相关 end  ****************************************************/

// 活动投稿-活动信息
export const ActivityInfo = params =>
    axios.get(`${urlPrefix}/activity/info`, {
        params: params
    });
// 活动投稿-图文投稿
export const ActivityText = params =>
    axios.post(`${urlPrefix}/articles/activity/text`, params);
// 活动投稿-视频投稿
export const ActivityVideo = params =>
    axios.post(`${urlPrefix}/articles/activity/video`, params);

// 开放平台账号-应用申请
export const ApplicationApply = params =>
    axios.post(`${urlPrefix}/open/application/apply`, params);

// 开放平台账号-应用列表(创建)
export const ApplicationList = () =>
    axios.get(`${urlPrefix}/open/application/list`);

// 开放平台账号-应用列表(授权)
export const ApplicationAuthList = () =>
    axios.get(`${urlPrefix}/open/application/auth/list`);

// 开放平台账号-应用信息
export const ApplicationInfo = params =>
    axios.get(`${urlPrefix}/open/application/info`, {
        params: params
    });

// 开放平台账号-应用删除
export const ApplicationDelete = params =>
    axios.delete(`${urlPrefix}/open/application`, {
        data: params
    });

// 开放平台账号-授权用户
export const ApplicationUser = params =>
    axios.get(`${urlPrefix}/open/application/user`, {
        params: params
    });

// 开放平台账号-用户应用授权
export const ApplicationUserAuth = params =>
    axios.post(`${urlPrefix}/open/application/user/auth`, params);

// 开放平台账号-用户应用取消授权
export const ApplicationUserUnauth = params =>
    axios.post(`${urlPrefix}/open/application/user/unauth`, params);

// 开放平台账号-授权用户
export const ApplicationFind = params =>
    axios.get(`${urlPrefix}/open/application/find`, {
        params: params
    });

// 用户授权 - QQ授权登录链接
export const OpenQQLoginUrl = params =>
    axios.get(`${openUrl}/open/qq/login/url`, {
        params: params
    });

// 用户授权 - 微信授权登录链接
export const OpenWXLoginUrl = params =>
    axios.get(`${openUrl}/open/wx/login/url`, {
        params: params
    });

// 用户授权 - 保存TGL openid
export const OpenSaveOpenid = params =>
    axios.post(`${openUrl}/open/save/openid`, params);

// 腾讯云获取签名
export const QcloudKey = params =>
    axios.get(`${urlPrefix}/attachment/qcloud/key`, {
        params: params
    });

// 腾讯云视频保存
export const QcloudVideoSave = params =>
    axios.post(`${urlPrefix}/attachment/qcloud/video/save`, params);

// 腾讯云预览
export const QcloudVideoView = params =>
    axios.get(`${urlPrefix}/attachment/qcloud/video/view`, {
        params: params
    });

// 腾讯云点播上传
export const QcloudUgckey = params =>
    axios.get(`${urlPrefix}/attachment/qcloud/ugckey`, {
        params: params
    });

// 腾讯云点播预览
export const QcloudUgcvideoView = params =>
    axios.get(`${urlPrefix}/attachment/qcloud/ugcvideo/view`, {
        params: params
    });

// 腾讯云点播视频保存
export const QcloudUgcvideoSave = params =>
    axios.post(`${urlPrefix}/attachment/qcloud/ugcvideo/save`, params);

// 腾讯云点播预览参数
export const QcloudUgcvideoWebview = params =>
    axios.get(`${urlPrefix}/attachment/qcloud/ugcvideo/webview`, {
        params: params
    });

// 云点播视频信息
export const QcloudUgcvideoInfo = params =>
    axios.get(`${urlPrefix}/attachment/qcloud/ugcvideo/info`, {
        params: params
    });

// 获取PC端公告列表
export const AnnounceQqlist = () => axios.get(`${urlPrefix}/announce/qqlist`);

// 获取PC端公告详情
export const AnnounceDetail = params =>
    axios.get(`${urlPrefix}/announce/detail`, {
        params: params
    });

// 老版v3任务投稿
export const ArticlesV3Text = params =>
    axios.post(`${urlPrefix}/articles/v3/text`, params);

// 老版v3任务投稿
export const ArticlesV3Video = params =>
    axios.post(`${urlPrefix}/articles/v3/video`, params);

// 老版任务投稿列表
export const ArticlesV3List = params =>
    axios.get(`${urlPrefix}/articles/v3/list`, {
        params: params
    });

// 老版任务投稿详情
export const ArticlesV3Detail = params =>
    axios.get(`${urlPrefix}/articles/v3/detail`, {
        params: params
    });

// 活动抽奖
export const ActivityRoll = params =>
    axios.post(`${urlPrefix}/activity/roll`, params);

// 赞赏申请
export const RewardApply = params =>
    axios.post(`${urlPrefix}/reward/apply`, params);

// 赞赏申请信息
export const RewardInfo = params =>
    axios.get(`${urlPrefix}/reward/info`, {
        params: params
    });

// 同步账户昵称
export const UserNickName = params =>
    axios.post(`${urlPrefix}/user/nickName`, params);

// 获取用户打赏的QQ和微信账号
export const UserRewardAccount = params =>
    axios.get(`${urlPrefix}/user/reward/account`, {
        params: params
    });

// 用户静态化内容列表
export const RewardContent = params =>
    axios.get(`${urlPrefix}/reward/content`, {
        params: params
    });

// 数据收益模块，用户赞赏总览
export const RewardStatistic = params =>
    axios.get(`${urlPrefix}/reward/statistic`, {
        params: params
    });

// 数据收益模块，赞赏明细
export const RewardListFlow = params =>
    axios.get(`${urlPrefix}/reward/list/flow`, {
        params: params
    });

// 数据收益模块，按文章数据
export const RewardListArticle = params =>
    axios.get(`${urlPrefix}/reward/list/article`, {
        params: params
    });

// 数据收益模块，按天数据
export const RewardListDaily = params =>
    axios.get(`${urlPrefix}/reward/list/daily`, {
        params: params
    });

// 游戏推广申请
export const DownloadApply = params =>
    axios.post(`${urlPrefix}/download/apply`, params);

// 游戏推广任务列表
export const DownloadTaskList = params =>
    axios.get(`${urlPrefix}/download/task/list`, {
        params: params
    });

// 游戏推广任务详情
export const DownloadTaskInfo = params =>
    axios.get(`${urlPrefix}/download/task/info`, {
        params: params
    });

// 游戏推广参加任务
export const DownloadTaskJoin = params =>
    axios.post(`${urlPrefix}/download/task/join`, params);

// 游戏推广用户文章
export const DownloadUserArticles = params =>
    axios.get(`${urlPrefix}/download/user/articles`, {
        params: params
    });

// 获取用户参与文章列表
export const DownloadTaskJoined = params =>
    axios.get(`${urlPrefix}/download/task/joined`, {
        params: params
    });

// 游戏推广 - 获取用户参与任务数据列表
export const DownloadTaskData = params =>
    axios.get(`${urlPrefix}/download/task/data`, {
        params: params
    });

// 游戏推广 - 获取用户单独pageUrl
export const DownloadTaskPage = params =>
    axios.get(`${urlPrefix}/download/task/page`, {
        params: params
    });

// 游戏推广 - 获取用户tab白名单显示
export const DownloadAccess = params =>
    axios.get(`${urlPrefix}/download/access`, {
        params: params
    });

// 游戏推广 - 数据统计-数据汇总
export const DownloadDataTotal = params =>
    axios.get(`${urlPrefix}/download/data/total`, {
        params: params
    });

// 游戏推广 - 数据统计-任务数据
export const DownloadDataTask = params =>
    axios.get(`${urlPrefix}/download/data/task`, {
        params: params
    });

// 游戏推广 - 数据统计-按天数据
export const DownloadDataDaily = params =>
    axios.get(`${urlPrefix}/download/data/daily`, {
        params: params
    });

// 游戏推广 - 获取用户参与任务数据列表(小时级)
export const DownloadTaskDataHour = params =>
    axios.get(`${urlPrefix}/download/task/data/hour`, {
        params: params
    });

// 任务数据-去重人数详情
export const DownloadDataTaskDetail = params =>
    axios.get(`${urlPrefix}/download/data/task/detail`, {
        params: params
    });

// 按天数据-去重人数详情
export const DownloadDataDailyDetail = params =>
    axios.get(`${urlPrefix}/download/data/daily/detail`, {
        params: params
    });

// 根据文章id获取文章敏感词
export const ArticlesSenseWord = params =>
    axios.get(`${urlPrefix}/articles/senseWord`, {
        params: params
    });
// 文件上传签名
export const Uploadv2FilePutAuth = params =>
    axios.get(`${tglPrefix}/uploadv2/file/put/auth`, {
        params: params
    });

// 文件服务 - 上传需求单验收件
export const Uploadv2DemandzipUpload = params =>
    axios.post(`${tglPrefix}/uploadv2/demandzip/upload`, params);

// mcn实名认证
export const McnRealNameAuth = params =>
    axios.post(`${urlPrefix}/user/mcn/realName/auth`, params);

// mcn认证
export const McnUserAuth = params =>
    axios.post(`${urlPrefix}/user/mcn/auth`, params);

// 获取mcn信息
export const McnUserInfo = params =>
    axios.get(`${urlPrefix}/user/mcn/info`, {
        params: params
    });

// 腾讯云剪 - 创建项目
export const CmeProjectCreate = params =>
    axios.post(`${urlPrefix}/cme/project/create`, params);

// 腾讯云剪 - 项目更新
export const CmeprojectUpdate = params =>
    axios.post(`${urlPrefix}/cme/project/update`, params);

// 腾讯云剪 - 操作签名
export const CmeSignature = params =>
    axios.get(`${urlPrefix}/cme/signature`, {
        params: params
    });

// 腾讯云剪 - 导出项目
export const CmeProjectExport = params =>
    axios.post(`${urlPrefix}/cme/project/export`, params);

// 腾讯云剪 - 删除项目
export const CmeProjectDelete = params =>
    axios.post(`${urlPrefix}/cme/project/delete`, params);

// 腾讯云剪 - 项目列表
export const CmeProjectList = params =>
    axios.get(`${urlPrefix}/cme/project/list`, { params });

// 腾讯云剪 - 成片列表
export const CmeCreatureList = params =>
    axios.get(`${urlPrefix}/cme/creature/list`, { params });

// 腾讯云剪 - 成片信息
export const CmeCreatureInfo = params =>
    axios.get(`${urlPrefix}/cme/creature/info`, { params });

// 腾讯云剪 - 成片下载
export const CmeCreatureDownload = params =>
    axios.get(`${urlPrefix}/cme/creature/download`, { params });

// 腾讯云剪 - 成片删除
export const CmeCreatureDelete = params =>
    axios.post(`${urlPrefix}/cme/creature/delete`, params);

// 腾讯云剪 - 成片投稿
export const CmeCreatureContribute = params =>
    axios.post(`${urlPrefix}/cme/creature/contribute`, params);
